import * as React from 'react';

import * as styles from './salary_field.css';
import { Checkbox, InputGroup, NumberInput, Tooltip } from '@cian/ui-kit';
import { MAX_SALARY } from '../../../constants/salary';

interface ISalaryFieldProps {
  isValid: boolean;
  className: string;
  minValue?: number;
  maxValue?: number;
  byAgreementValue: boolean;
  minChange(value: number): void;
  maxChange(value: number): void;
  byAgreementChange(e: React.ChangeEvent<HTMLInputElement>, value: boolean): void;
}

const SalaryField = (props: ISalaryFieldProps) => (
  <div className={props.className}>
    <div className={styles['clear']}>
      <div className={styles['range_wrapper']}>
        <div className={styles['range']}>
          <InputGroup>
            <NumberInput
              min={0}
              max={MAX_SALARY}
              invalid={!props.isValid}
              onChange={props.minChange}
              placeholder="от"
              value={props.minValue}
            />
            <NumberInput
              min={0}
              max={MAX_SALARY}
              invalid={!props.isValid}
              onChange={props.maxChange}
              placeholder="до"
              value={props.maxValue}
            />
          </InputGroup>
        </div>
        <span className={styles['text']}>₽/мес.</span>
      </div>
      {!props.isValid && (
        <div className={styles['tooltip_wrapper']}>
          <Tooltip title="Укажите зарплату" placement="right">
            <span>&nbsp;</span>
          </Tooltip>
        </div>
      )}
    </div>
    <div className={styles['checkbox']}>
      <Checkbox
        invalid={!props.isValid}
        label="По договорённости"
        checked={props.byAgreementValue}
        onChange={props.byAgreementChange}
      />
    </div>
  </div>
);

export { SalaryField };
